import { CurrentHealthcarePracticeQuery, HealthcarePractice } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useCurrentHealthcarePracticeQuery = (): UseCqrsQueryResult<HealthcarePractice> => {
   return useCqrsGet<HealthcarePractice>(() => {
      return new CurrentHealthcarePracticeQuery();
   });
};
